<div class="header-container" style="display: flex; align-items: center; justify-content: space-between; margin-top: 10px; padding: 0 10px;">
  <div class="header-text" style="flex: 1; text-align: center;">
    <p style="font-size: 1.2em; font-weight: 600; margin-bottom: 5px;">{{ title() }}</p>
    <p style="font-size: 1.2em; margin-top: 0;" i18n>Select a poll to begin making selections.</p>
  </div>
  @if(polls.length > 4) {
    <button mat-icon-button (click)="toggleSearch()" 
      aria-label="Toggle Search" 
      style="flex-shrink: 0;"
      matTooltip="{{tooltipTextForSSFIcon}}"
      matTooltipPosition="above">
      <mat-icon>{{ showSearchInput ? 'close' : 'search' }}</mat-icon>
    </button>
  }
</div>

@if(showSearchInput) {
  <!-- Controls Bar -->
  <mat-card class="search-sort-filter-card">

    <!-- Search -->
    <div class="search-sort-filter-group">
      <mat-form-field appearance="outline" class="search-field"
        matTooltip="{{tooltipTextForSearch}}"
        matTooltipPosition="above">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput 
          name="search"
          type="text" 
          maxlength="40"
          (keypress)="validateKeyPress($event)"
          (paste)="validatePaste($event)"
          [(ngModel)]="searchTerm"
          [placeholder]="searchPlaceholder" 
          i18n-placeholder />
        <mat-label i18n>Search</mat-label>
      </mat-form-field>

      <!-- Sort Dropdown -->
      <mat-form-field appearance="outline" class="sort-field"
        matTooltip="{{tooltipTextForSort}}"
        matTooltipPosition="above">
        <mat-label i18n>Sort by</mat-label>
        <mat-select [(value)]="sortOrder" (selectionChange)="changeSortOrder($event.value)">
          <mat-option value="NEWEST_FIRST" i18n>Newest First</mat-option>
          <mat-option value="OLDEST_FIRST" i18n>Oldest First</mat-option>
          <mat-option value="EXPIRATION_ASCENDING" i18n>Closes Soonest</mat-option>
          <mat-option value="EXPIRATION_DESCENDING" i18n>Closes Latest</mat-option>
        </mat-select>
      </mat-form-field>
      
      <!-- Filter Toggle Button -->
      <button mat-stroked-button (click)="toggleFilterVisibility()" class="filter-button"
        matTooltip="{{tooltipTextForFilter}}">
        <mat-icon class="filter-icon">filter_list</mat-icon>
        <span i18n>Filters</span>
      </button>
    </div>
      
    <!-- Filter Options -->
    @if(showFilters) {
      <div class="filter-options">
        <mat-divider></mat-divider>
        <div class="filter-options-content">
          <p class="filter-label" i18n>Filter Inactive Polls:</p>
          <div class="checkbox-group">
            <mat-checkbox color="primary" 
              matTooltip="{{tooltipTextForSeparateEvents}}"
              matTooltipPosition="above" 
              [(ngModel)]="separateInactive" i18n>
              Separate Inactive Polls
            </mat-checkbox>
            <mat-checkbox color="primary" 
              matTooltip="{{tooltipTextForExcludeEvents}}"
              matTooltipPosition="above"
              [(ngModel)]="excludeInactive" i18n>
              Exclude Inactive Polls
            </mat-checkbox>
          </div>
        </div>
      </div>
    }
  </mat-card>
}

<div role="list">
  @for (poll of filteredAndSortedBallots; track poll.eventId) {
    <button i18n (click)="goToPoll(poll.eventId)" role="listitem"
      [disabled]="!ballotListService.isActionable(poll) && !canViewResults(poll)" [ngClass]="{
        'button-container': true,
        'button-container-expired': !ballotListService.isActionable(poll) && !canViewResults(poll)
      }">
      <img src={{eventImage(poll)}} class="vtz-primary-header__img" alt=""/>
      <span class="button-text">
        {{ poll.voteEventData.description}} <br>
        @if (poll.voteEventData.description1) {
          {{ poll.voteEventData.description1}} <br>
        }
        @if ( poll.voteEventData.description2) {
          {{ poll.voteEventData.description2}}<br>
        }
        @if (ballotListService.isEventOpen(poll.eventExpiration)){
          Closes: {{ poll.eventExpiration | date:'EEEE, MMMM d, y, h:mm a' }}
        } @else {
          Closed on: {{poll.eventExpiration | date:'EEEE, MMMM d, y, h:mm a' }}
        }
        @switch(ballotListService.eventStatus(poll)) {
          @case('VOTE') {
            <span class="status-badge status-green">RESPOND</span>
          }
          @case('CLOSES_SOON') {
            <span class="status-badge status-yellow">CLOSES SOON</span>
          }
          @case('CLOSES_VERY_SOON') {
            <span class="status-badge status-orange">CLOSES SOON</span>
          }
          @case('SUBMITTED') {
            <span class="status-badge status-blue">RESPONSE SUBMITTED</span>
          }
          @case('CAN_CHANGE') {
            <span class="status-badge status-blue">CHANGE RESPONSE</span>
          }
          @case('EXPIRED') {
            <span class="status-badge status-red">POLL CLOSED</span>
          }
        }
        @if(canViewResults(poll)) {
          <span class="status-badge status-purple">VIEW RESULTS</span>
        }
      </span>
      @if(canViewResults(poll)) {
        <mat-icon class="button-icon">insert_chart_outlined</mat-icon>
      }
      @if (ballotListService.isActionable(poll)) {
        <mat-icon class="button-icon">launch</mat-icon>
      }
    </button>
  }
</div>
